export default __webpack_public_path__ + "static/venn-icon-f69832a4ed53240cd02c8f6b75c4e224.png";